import { getPath } from "../../utils/paths";
import _ from "lodash";
import { asyncForEach } from "../../common/windowFunctions";
const pathArrayToString = (path) => {
    let pathString = null;
    if (path && path.length > 0) {
        pathString = path.join(".");
    }
    return pathString;
};
export class BaseStore {
    constructor(params) {
        this.params = params;
        this.values = {};
        this.listeners = {};
        this.Dispatcher = {
            register: () => {
            },
            dispatch: () => {
            }
        };
        this.isGlobal = params.global ?? false;
        this.name = params.store;
        this.values = params.values ?? {};
    }
    async init() {
        await this.initCore();
    }
    addListener(params, fn, cb) {
        let fields = "";
        if (Array.isArray(params)) {
            fields = params.join(".");
        }
        else {
            fields = params.field ?? "";
        }
        let array = this.listeners[fields];
        if (!array) {
            array = [];
            this.listeners[fields] = array;
        }
        array.push(fn);
    }
    addListeners(params, fn, cb) {
        for (const param of params) {
            let item = { field: "", listener: fn };
            if (typeof param === "string") {
                item.field = param;
            }
            else if (typeof param.field === "string") {
                item = { field: param.field, listener: param.listener ?? fn };
            }
            else if (Array.isArray(param.field)) {
                item = { field: param.field.join("."), listener: param.listener ?? fn };
            }
            if (!item.listener) {
                throw new Error(`no listener defined for field ${item.field}`);
            }
            this.addListener({ field: item.field }, item.listener);
        }
        if (cb) {
            cb();
        }
    }
    destroy(cb) {
        this.listeners = {};
        return this.destroyCore(cb);
    }
    async get(path, cb) {
        const field = pathArrayToString(path);
        const data = this.getValue(field, cb);
        return {
            err: undefined,
            data
        };
    }
    async getMultiple(paths, cb) {
        const strings = paths.map((p) => pathArrayToString(p));
        const stringsNoNulls = [];
        for (const str of strings) {
            if (str) {
                stringsNoNulls.push(str);
            }
        }
        const data = _.pick(this.values, stringsNoNulls);
        return {
            err: null,
            response: {
                data
            }
        };
    }
    getAll(cb) {
        cb(null, this.values);
    }
    async getGlobal(path, cb) {
        const str = pathArrayToString(path);
        const data = getPath(str, this.values);
        cb?.(null, data);
        return {
            err: null,
            data
        };
    }
    getValue(params, cb) {
        let path = null;
        if (params !== null) {
            path = typeof params === "string" ? params : params.field;
        }
        const result = getPath(path, this.values);
        cb?.(null, result);
        return result;
    }
    async getGlobalValue(params, cb) {
        const data = await this.getValue(params, cb);
        cb?.(null, data);
        return {
            err: null,
            data
        };
    }
    async getValues(fields, cb) {
        const result = {};
        for (const field of fields ?? []) {
            const value = await this.getValue(field);
            const path = typeof field === "string" ? field : field.field;
            result[path] = value.data;
        }
        if (cb) {
            cb(null, result);
        }
        return {
            err: null,
            data: result
        };
    }
    async removeListener(params, fn, cb) {
        let fields = "";
        if (Array.isArray(params)) {
            fields = params.join(".");
        }
        else {
            fields = params.field ?? "";
        }
        const listeners = (this.listeners[fields] ?? []).filter((listener) => listener !== fn);
        this.listeners[fields] = listeners;
        if (!this.listeners[fields].length) {
            delete this.listeners[fields];
        }
    }
    async removeListeners(params, fn, cb) {
        const paramsArray = Array.isArray(params) ? params : [params];
        await asyncForEach(paramsArray, async (param) => {
            const field = Array.isArray(param.field) ? pathArrayToString(param.field) : param.field;
            if (field) {
                await this.removeListener({ field }, param.listener);
            }
        });
        cb?.(null);
    }
    async remove(path, cb) {
        const field = path.join(".");
        await this.setValue({ field, value: null });
        return {
            err: null,
            data: undefined
        };
    }
    async removeMultiple(paths, cb) {
        return this.setMultiple(paths.map((field) => {
            return {
                field,
                value: null
            };
        }));
    }
    removeValue(params, cb) {
        return this.setValue({ field: params.field ?? params, value: null }, cb);
    }
    removeValues(params, cb) {
        const fields = params.map((p) => {
            return {
                field: params.field ?? params, value: null
            };
        });
        return this.setValues(fields);
    }
    async set(path, value, cb) {
        const field = path.join(".");
        await this.setValue({ field, value });
        return {
            err: null,
            data: undefined
        };
    }
    async setMultiple(pathsAndValues, cb) {
        await asyncForEach(pathsAndValues, async (pv) => {
            await this.set(pv.field, pv.value);
        });
        cb?.(null);
        return { err: null };
    }
    setValue(params, cb) {
        return this.setValueCore(params, cb);
    }
    async setValues(fields, cb) {
        for (const field of fields) {
            await this.setValue(field);
        }
        if (cb) {
            cb(null);
        }
    }
    initCore() {
    }
    destroyCore(cb) {
    }
    setValueCore(params, cb) {
    }
    notifyListeners(path) {
        for (const listenerPath of Object.keys(this.listeners)) {
            if (listenerPath !== path && listenerPath !== "") {
                continue;
            }
            const value = listenerPath === "" ? this.values : getPath(listenerPath, this.values);
            const handlerForTopic = this.listeners[listenerPath];
            const fullPath = listenerPath;
            handlerForTopic.forEach((handler) => {
                try {
                    handler(null, {
                        field: fullPath,
                        value
                    });
                }
                catch (e) {
                    console.log("DistributedStore notifyListeners error in handler", e);
                }
            });
        }
    }
}
